import $ from 'jquery';
import { aos } from './main/aos.js';
import AOS from 'aos';
import { mmenuStarter } from './main/mmenu.js';
import { lazyLoad } from './main/lazyload.js';
import { gallery } from './main/gallery.js';

//component files
// import { faq } from '../../components/faqs/js/index';


$(function() {
	// Handler for .ready() called.

	new mmenuStarter();
	new aos();
	new lazyLoad();
	new gallery();
	
	//Fix conflict between AOS and Slick Slider
	AOS.refresh();

	console.log('main.js running');
});

